import useDetectSizeDevice from "@/hooks/useDetectSizeDevice";
import { useState, type FC } from "react";
import OnboardingAddRestaurantsStep1 from "../OnboardingAddRestaurantsStep1";
import OnboardingAddRestaurantsStep2 from "../OnboardingAddRestaurantsStep2";
import type { RestaurantAutocompleteResult } from "@/API";
import OnboardingAddRestaurantsStep3 from "../OnboardingAddRestaurantsStep3";
import { addUserRestaurants } from "@/store/userAddRestaurantsState";
import { useNavigate } from "react-router";
import { setActionTriggerModalTrialModal } from "@/store/restrictedFeatureState";

const OnboardingAddRestaurants: FC = () => {
  const { sm } = useDetectSizeDevice();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [restaurants, setRestaurants] = useState<
    RestaurantAutocompleteResult[]
  >([]);
  const [restaurantsSelected, setRestaurantsSelected] = useState<
    RestaurantAutocompleteResult[]
  >([]);

  return (
    <div
      style={{
        height: sm
          ? "calc(100dvh - var(--height-header))"
          : "calc(100dvh - var(--height-header) - var(--height-header-not-sm))",
        paddingTop: !sm ? 80 : 32,
      }}
      className="bg-[#F7F8F9] w-[100%] flex items-center justify-center px-[16px] py-[32px] overflow-y-auto"
    >
      <div className="bg-[white] rounded-[16px] p-[32px] w-[100%] sm:w-[825px] sm:max-w-[825px]">
        {step === 1 && (
          <OnboardingAddRestaurantsStep1
            setRestaurants={setRestaurants}
            restaurants={restaurants}
            nextStep={() => {
              setRestaurantsSelected(restaurants);
              setStep(2);
            }}
          />
        )}
        {step === 2 && (
          <OnboardingAddRestaurantsStep2
            onComplete={() => {
              setStep(3);
            }}
          />
        )}
        {step === 3 && (
          <OnboardingAddRestaurantsStep3
            setRestaurantsSelected={setRestaurantsSelected}
            restaurantsSelected={restaurantsSelected}
            restaurants={restaurants}
            finish={() => {
              addUserRestaurants(
                restaurantsSelected.map((restaurant) => restaurant.id),
              );
              setActionTriggerModalTrialModal(true);
              navigate("/");
            }}
            restart={() => {
              setRestaurantsSelected([]);
              setStep(1);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OnboardingAddRestaurants;
